// Auto generated by typegen from Prisma Schema

export enum PlatformId {
	shopify = "shopify",
	woocommerce = "woocommerce",
	magento = "magento",
	bigcommerce = "bigcommerce",
	api = "api",
	fluid = "fluid",
}

export enum StoreType {
	ACTIVE = "ACTIVE",
	DEV = "DEV",
	INACTIVE = "INACTIVE",
	ONBOARDING = "ONBOARDING",
}

export enum EscalationQueue {
	NEW = "NEW",
	OPEN = "OPEN",
}

export enum EscalationTrigger {
	VALUE_GUARDRAIL = "VALUE_GUARDRAIL",
	SOP_REQUIRES_APPROVAL = "SOP_REQUIRES_APPROVAL",
	BRAND_OWNED = "BRAND_OWNED",
	FRAUD_RISK = "FRAUD_RISK",
	CUSTOMER_REQUESTED_HUMAN = "CUSTOMER_REQUESTED_HUMAN",
	LEGAL_OR_SAFETY = "LEGAL_OR_SAFETY",
	EVIDENCE_REVIEW = "EVIDENCE_REVIEW",
	CUSTOMER_UNRESPONSIVE = "CUSTOMER_UNRESPONSIVE",
	NO_ENABLED_RESOLUTION = "NO_ENABLED_RESOLUTION",
	TOOL_OR_PLATFORM_LIMIT = "TOOL_OR_PLATFORM_LIMIT",
	PRICING_FAILURE = "PRICING_FAILURE",
	OTHER = "OTHER",
}

export enum PricingModel {
	COST_PER_ORDER = "COST_PER_ORDER",
	COST_PER_ORDER_ITEM = "COST_PER_ORDER_ITEM",
	COST_PER_RESOLUTION = "COST_PER_RESOLUTION",
}

export enum PricingOperator {
	AND = "AND",
	OR = "OR",
}

export enum CalcMethod {
	percentage = "percentage",
	fixed = "fixed",
}

export enum CountryRule {
	ALL = "ALL",
	ONLY = "ONLY",
	EXCEPT = "EXCEPT",
}

export enum PriceRoundingMode {
	ROUND_DOWN = "ROUND_DOWN",
	ROUND_UP = "ROUND_UP",
	NEAREST = "NEAREST",
}

export enum ButtonType {
	ROUNDED = "ROUNDED",
	ROUNDED_FULL = "ROUNDED_FULL",
	SQUARE = "SQUARE",
}

export enum TextTransform {
	none = "none",
	uppercase = "uppercase",
	lowercase = "lowercase",
	capitalize = "capitalize",
}

export enum ClaimType {
	STOLEN = "STOLEN",
	DAMAGED = "DAMAGED",
	DEFECTIVE_ITEM = "DEFECTIVE_ITEM",
	ORDER_DELIVERED_NOT_RECEIVED = "ORDER_DELIVERED_NOT_RECEIVED",
	WRONG_ITEM = "WRONG_ITEM",
	MISSING_ITEM = "MISSING_ITEM",
	RETURNED_TO_SENDER = "RETURNED_TO_SENDER",
	TRACKING_NOT_MOVING = "TRACKING_NOT_MOVING",
	MULTIPLE = "MULTIPLE",
	WRONG_ADDRESS = "WRONG_ADDRESS",
}

export enum PolicyType {
	SHIPPING = "SHIPPING",
	MANUFACTURER_WARRANTY = "MANUFACTURER_WARRANTY",
	EXTENDED_WARRANTY = "EXTENDED_WARRANTY",
}

export enum EvidenceType {
	PHOTO = "PHOTO",
	VIDEO = "VIDEO",
	POLICE_REPORT = "POLICE_REPORT",
	TRACKING = "TRACKING",
}

export enum StackingRule {
	COMPOUND = "COMPOUND",
	MOST_FAVORABLE = "MOST_FAVORABLE",
}

export enum RiskRoutingAction {
	AUTO_APPROVE = "AUTO_APPROVE",
	LIGHTWEIGHT_VALIDATION = "LIGHTWEIGHT_VALIDATION",
	REDUCED_REIMBURSEMENT = "REDUCED_REIMBURSEMENT",
}

export enum YofiRiskTier {
	LOW = "LOW",
	MEDIUM = "MEDIUM",
	HIGH = "HIGH",
}

export enum OtaLimit {
	ONCE = "ONCE",
	TWICE = "TWICE",
	EVERY_6_MONTHS = "EVERY_6_MONTHS",
	EVERY_12_MONTHS = "EVERY_12_MONTHS",
}

export enum StoreCreditType {
	GIFT_CARD = "GIFT_CARD",
	DISCOUNT_CODE = "DISCOUNT_CODE",
	ACCOUNT_CREDIT = "ACCOUNT_CREDIT",
}

export enum InventoryManagement {
	ALWAYS_DECREMENT = "ALWAYS_DECREMENT",
	NEVER_DECREMENT = "NEVER_DECREMENT",
	FOLLOW_INVENTORY_POLICY = "FOLLOW_INVENTORY_POLICY",
}

export enum TestType {
	WIDGET = "WIDGET",
	PRICE = "PRICE",
	WIDGET_STYLE = "WIDGET_STYLE",
}

export enum TestState {
	ACTIVE = "ACTIVE",
	INACTIVE = "INACTIVE",
	COMPLETED = "COMPLETED",
}

export enum ReplacementCost {
	NO_COST = "NO_COST",
	PRICE_OF_ORIGINAL_ORDER_AFTER_DISCOUNTS = "PRICE_OF_ORIGINAL_ORDER_AFTER_DISCOUNTS",
	FULL_RETAIL_PRICE = "FULL_RETAIL_PRICE",
	FULL_RETAIL_PRICE_FULLY_DISCOUNTED = "FULL_RETAIL_PRICE_FULLY_DISCOUNTED",
}

export enum ResolutionValueBasis {
	PRICE_PAID = "PRICE_PAID",
	RETAIL_PRICE = "RETAIL_PRICE",
}

export enum CoverageMode {
	OP_LINE = "OP_LINE",
	INCLUDED_IN_SHIPPING = "INCLUDED_IN_SHIPPING",
}

export enum FulfillmentTime {
	IMMEDIATELY = "IMMEDIATELY",
	AFTER_FIRST_PRODUCT = "AFTER_FIRST_PRODUCT",
	AFTER_ALL_PRODUCTS = "AFTER_ALL_PRODUCTS",
	NEVER = "NEVER",
}

export enum SopRefreshCadence {
	WEEKLY = "WEEKLY",
	BIWEEKLY = "BIWEEKLY",
	MONTHLY = "MONTHLY",
	OFF = "OFF",
}

export enum PriceRuleSetType {
	SHIPPING = "SHIPPING",
	MANUFACTURER_WARRANTY = "MANUFACTURER_WARRANTY",
	EXTENDED_WARRANTY = "EXTENDED_WARRANTY",
	STORE_CREDIT = "STORE_CREDIT",
}

export enum WidgetType {
	CART = "CART",
	CHECKOUT = "CHECKOUT",
	INFO_MODAL = "INFO_MODAL",
	SUBSCRIPTION = "SUBSCRIPTION",
}

export enum WidgetStatus {
	ACTIVE = "ACTIVE",
	DRAFT = "DRAFT",
}

export enum SopState {
	ACTIVE = "ACTIVE",
	INACTIVE = "INACTIVE",
	DRAFT = "DRAFT",
}

export enum SopSource {
	MERCHANT = "MERCHANT",
	GORGIAS = "GORGIAS",
	SLACK = "SLACK",
}

export enum MacroStatus {
	DEFAULT = "DEFAULT",
	CUSTOM = "CUSTOM",
	OVERRIDE = "OVERRIDE",
	ARCHIVED = "ARCHIVED",
}

export enum CustomDomainStatus {
	PENDING_DNS = "PENDING_DNS",
	PROVISIONING = "PROVISIONING",
	ACTIVE = "ACTIVE",
	FAILED = "FAILED",
	DELETING = "DELETING",
}

export enum CustomDomainAuthMode {
	DNS_AUTHORIZATION = "DNS_AUTHORIZATION",
	LOAD_BALANCER = "LOAD_BALANCER",
}

export interface Store {
	id: string;
	slug: string;
	name: string;
	accountId: string;
	accountName: string | null;
	parentAccountName: string | null;
	contactEmail: string | null;
	contactPhone: string | null;
	storeUrl: string | null;
	storeDomain: string;
	createdAt: string;
	updatedAt: string | null;
	deletedAt: string | null;
	platformId: PlatformId;
	storeIndustry: string | null;
	primaryMarketCountry: string | null;
	storeType: StoreType;
	storeSettings: StoreSetting | null;
	contactSettings: ContactSetting | null;
	generalSettings: GeneralSetting | null;
	capabilityId: string | null;
	warrantySettings: WarrantySettings | null;
	offlineClaimSettings: OfflineClaimSettings | null;
	warranty: Warranty[];
	activatedAt: string | null;
	whitelabelSettings: BrandingSetting[];
	pricingRules: PriceRuleSet[];
	macros: MacrosStore[];
	capabilities: Capability | null;
	tests: Test[];
	sops: Sop[];
	widgetConfiguration: WidgetConfiguration[];
	claimSettings: ClaimSettings | null;
	defaultMacrosStoreHelper: DefaultMacrosStoreHelper[];
	claimAutomationSettings: ClaimAutomationSettings | null;
	partnerSettingsContexts: PartnerSettingsContext[];
	coverageRules: CoverageRule[];
	helpDeskSopSettings: HelpDeskSopSettings | null;
	customDomains: CustomDomain[];
}

export interface Capability {
	id: string;
	credit: boolean;
	refund: boolean;
	reship: boolean;
	draftOrder: boolean;
	customizations: boolean;
	customClaims: boolean;
	customEmails: boolean;
	customInfoModals: boolean;
	customWidgets: boolean;
	inventory: boolean;
	splitTest: boolean;
	returns: boolean;
	returnsIndex: boolean;
	sop: boolean;
	warranties: boolean;
	manufacturerWarranties: boolean;
	extendedWarranties: boolean;
	claimSubtypes: boolean;
	warrantiesMetafieldsImport: boolean;
	claimAutomation: boolean;
	offlineClaims: boolean;
	productSync: boolean;
	updatedAt: string | null;
	store: Store;
	storeId: string;
}

export interface ClaimAutomationSettings {
	id: string;
	storeId: string;
	store: Store;
	threshold: number;
	claimValueThreshold: object | null;
	aiBotName: string | null;
	aiBotIcon: string | null;
	aiModelId: string | null;
	autoExecuteThreshold: number;
	autoExecuteConfidenceThreshold: number;
	thinking: boolean;
	allowedOrderTags: string[];
	escalationAutoApproveMaxAmount: number;
	escalationAutoApproveTriggers: EscalationTrigger[];
	createdAt: string;
	updatedAt: string | null;
	automationCapabilities: ClaimAutomationCapability | null;
	autoExecuteDelays: ClaimAutomationDelay[];
	notifications: ClaimAutomationNotification[];
	escalationThresholds: ClaimAutomationEscalationThreshold[];
}

export interface ClaimAutomationEscalationThreshold {
	id: string;
	settingsId: string;
	settings: ClaimAutomationSettings;
	claimType: ClaimType;
	queueState: EscalationQueue;
	queueSize: number;
	amount: number;
	createdAt: string;
	updatedAt: string | null;
}

export interface ClaimAutomationDelay {
	id: string;
	settingsId: string;
	settings: ClaimAutomationSettings;
	action: string;
	delayMinutes: number;
	createdAt: string;
	updatedAt: string | null;
}

export interface ClaimAutomationNotification {
	id: string;
	settingsId: string;
	settings: ClaimAutomationSettings;
	claimType: string;
	enabled: boolean;
	createdAt: string;
	updatedAt: string | null;
}

export interface ClaimAutomationCapability {
	id: string;
	claimAutomationSettingsId: string;
	stolen: boolean;
	damaged: boolean;
	defectiveItem: boolean;
	orderDeliveredNotReceived: boolean;
	wrongItem: boolean;
	missingItem: boolean;
	returnedToSender: boolean;
	trackingNotMoving: boolean;
	wrongAddress: boolean;
	refund: boolean;
	reship: boolean;
	storeCredit: boolean;
	autoExecuteStolen: boolean;
	autoExecuteDamaged: boolean;
	autoExecuteDefectiveItem: boolean;
	autoExecuteOrderDeliveredNotReceived: boolean;
	autoExecuteWrongItem: boolean;
	autoExecuteMissingItem: boolean;
	autoExecuteReturnedToSender: boolean;
	autoExecuteTrackingNotMoving: boolean;
	autoExecuteWrongAddress: boolean;
	updatedAt: string | null;
	automationSettings: ClaimAutomationSettings;
}

export interface StoreSetting {
	id: string;
	updatedAt: string | null;
	storeLogoUrl: string | null;
	enableCoBranding: boolean;
	store: Store | null;
	storeId: string | null;
}

export interface ContactSetting {
	id: string;
	storeId: string | null;
	store: Store | null;
	billingEmail: string | null;
	claimsEmail: string | null;
	sendClaimsEmailForAllClaims: boolean;
	sendClaimsEmailForEscalations: boolean;
	contactEmail: string | null;
	contactPhone: string | null;
	createdAt: string;
	updatedAt: string | null;
}

export interface PriceRule {
	id: string;
	minValue: number | null;
	maxValue: number;
	brandCalcMethod: CalcMethod | null;
	brandPrice: number | null;
	customerCalcMethod: CalcMethod | null;
	customerPrice: number | null;
	hybridOperator: PricingOperator | null;
	ruleSet: PriceRuleSet;
	priceRuleSetId: string;
	pricingModel: PricingModel | null;
	warrantyDuration: string | null;
	createdAt: string;
	updatedAt: string | null;
	deletedAt: string | null;
}

export interface Macros {
	id: string;
	folder: string;
	title: string | null;
	content: string | null;
	default: boolean;
	status: MacroStatus;
	pinned: boolean;
	stores: MacrosStore[];
	createdAt: string;
	updatedAt: string | null;
	deletedAt: string | null;
	parentMacroId: string | null;
	parentMacro: Macros | null;
	overrideMacros: Macros[];
	defaultMacrosStoreHelper: DefaultMacrosStoreHelper[];
}

export interface MacrosStore {
	id: string;
	macro: Macros;
	macroId: string;
	accountId: string;
	storeId: string | null;
	createdAt: string;
	updatedAt: string | null;
	store: Store | null;
}

export interface DefaultMacrosStoreHelper {
	id: string;
	macroId: string;
	macro: Macros;
	storeId: string;
	store: Store;
	pinned: boolean;
	archived: boolean;
	createdAt: string;
	updatedAt: string | null;
}

export interface BrandingSetting {
	id: string;
	storeId: string;
	store: Store;
	conciergeBrandingEnabled: boolean;
	brand100: string | null;
	brand700: string | null;
	brand800: string | null;
	brand900: string | null;
	buttonBorderRadius: string | null;
	buttonTextColor: string | null;
	buttonTextTransform: TextTransform;
	buttonBackgroundColor: string | null;
	buttonBackgroundHoverColor: string | null;
	customDomain: string | null;
	backgroundImage: string | null;
	backgroundColor: string | null;
	logoUrl: string | null;
	logoWidthMobile: string | null;
	logoWidthDesktop: string | null;
	faviconUrl: string | null;
	pageTitle: string | null;
	pageDescription: string | null;
	fontWoff: string | null;
	fontWoff2: string | null;
	fontWoff3: string | null;
	desktopHeadlineFontSize: string | null;
	mobileHeadlineFontSize: string | null;
	desktopHeadlineLineHeight: string | null;
	mobileHeadlineLineHeight: string | null;
	desktopHeadlineLetterSpacing: string | null;
	mobileHeadlineLetterSpacing: string | null;
	headlineTextColor: string | null;
	headlineTextTransform: TextTransform;
	desktopParagraphFontSize: string | null;
	mobileParagraphFontSize: string | null;
	desktopParagraphLineHeight: string | null;
	mobileParagraphLineHeight: string | null;
	desktopParagraphLetterSpacing: string | null;
	mobileParagraphLetterSpacing: string | null;
	paragraphTextColor: string | null;
	paragraphTextTransform: TextTransform;
	desktopSubTextFontSize: string | null;
	mobileSubTextFontSize: string | null;
	desktopSubTextLineHeight: string | null;
	mobileSubTextLineHeight: string | null;
	desktopSubTextLetterSpacing: string | null;
	mobileSubTextLetterSpacing: string | null;
	subTextColor: string | null;
	subTextTransform: TextTransform;
	selectorBackgroundColor: string | null;
	selectorBorderColor: string | null;
	inputActiveBorderColor: string | null;
	welcomeScreenTitle: string | null;
	welcomeScreenDescription: string | null;
	warrantyDescription: string | null;
	warrantyActionLinkText: string | null;
	claimSelectorTitle: string | null;
	claimSelectorShowItemCount: boolean | null;
	claimSelectorRestartText: string | null;
	claimSelectorShowRestart: boolean | null;
	shippingClaimTitle: string | null;
	shippingClaimDescription: string | null;
	shippingClaimButtonText: string | null;
	warrantyClaimTitle: string | null;
	warrantyClaimDescription: string | null;
	warrantyClaimButtonText: string | null;
	returnsTitle: string | null;
	returnsDescription: string | null;
	returnsButtonText: string | null;
	sectionHeaderColor: string | null;
	sectionSubTextColor: string | null;
	optionButtonBackground: string | null;
	optionButtonTextColor: string | null;
	optionButtonBorderColor: string | null;
	optionButtonRadius: string | null;
	createdAt: string;
	updatedAt: string | null;
}

export interface WarrantySettings {
	id: string;
	storeId: string;
	brandEmail: string | null;
	defaultWarrantyStatus: string;
	refundEnabled: boolean;
	reshipEnabled: boolean;
	storeCreditEnabled: boolean;
	store: Store;
	createdAt: string;
	updatedAt: string;
}

export interface OfflineClaimSettings {
	id: string;
	storeId: string;
	warrantyClaimsEnabled: boolean;
	shippingClaimsEnabled: boolean;
	receiptRequired: boolean;
	orderNumberOptional: boolean;
	externalSalesChannels: string[];
	allowCloseMatch: boolean;
	closeMatchMaxPriceIncreasePct: number;
	closeMatchMaxPriceDecreasePct: number;
	receiptPrefillEnabled: boolean;
	store: Store;
	createdAt: string;
	updatedAt: string;
}

export interface ClaimSettings {
	id: string;
	storeId: string;
	draftOrderShippingName: string | null;
	draftOrderShippingAmount: number;
	draftOrderInvoiceSubject: string;
	draftOrderInvoiceBody: string;
	includeOtasInReimbursements: boolean;
	store: Store;
	createdAt: string;
	updatedAt: string;
}

export interface CoverageRule {
	id: string;
	storeId: string;
	claimType: ClaimType;
	category: PolicyType;
	included: boolean;
	creditStore: boolean;
	store: Store;
	tiers: CoverageTier[];
	evidence: CoverageEvidence[];
	createdAt: string;
	updatedAt: string | null;
	deletedAt: string | null;
}

export interface CoverageTier {
	id: string;
	coverageRuleId: string;
	minAmount: number;
	maxAmount: number | null;
	reimbursementPct: number;
	coverageRule: CoverageRule;
}

export interface CoverageEvidence {
	id: string;
	coverageRuleId: string;
	type: EvidenceType;
	threshold: number | null;
	coverageRule: CoverageRule;
}

export interface RiskRoutingConfig {
	id: string;
	storeId: string;
	stackingRule: StackingRule;
	rules: RiskRoutingRule[];
	createdAt: string;
	updatedAt: string | null;
}

export interface RiskRoutingRule {
	id: string;
	configId: string;
	tier: YofiRiskTier;
	action: RiskRoutingAction;
	reimbursementPct: number | null;
	escalate: boolean;
	config: RiskRoutingConfig;
}

export interface Warranty {
	id: string;
	name: string;
	storeId: string;
	store: Store;
	warrantyRules: WarrantyRule[];
	createdAt: string;
	updatedAt: string;
}

export interface WarrantyRule {
	id: string;
	duration: string;
	warranty: Warranty;
	warrantyId: string;
	voidedAt: string | null;
}

export interface PriceRuleSet {
	id: string;
	storeId: string;
	store: Store;
	automaticallyAddToCart: boolean;
	noOp: boolean;
	rules: PriceRule[];
	tests: TestPriceRuleSet[];
	autoAddStateBlockList: string[];
	autoAddCountryBlockList: string[];
	roundingMode: PriceRoundingMode;
	minimumFee: number | null;
	updatedByApplicationId: string | null;
	autoAddUpdatedBy: string | null;
	autoAddUpdatedAt: string | null;
	createdAt: string;
	updatedAt: string | null;
	deletedAt: string | null;
	type: PriceRuleSetType;
}

export interface TestPriceRuleSet {
	id: string;
	testId: string;
	test: Test;
	title: string;
	isOriginal: boolean;
	priceRuleSetId: string;
	priceRuleSet: PriceRuleSet;
	weight: number | null;
	testEvents: TestEvent[];
	createdAt: string;
	updatedAt: string | null;
	deletedAt: string | null;
}

export interface Test {
	id: string;
	name: string;
	store: Store;
	storeId: string;
	percentOfTraffic: number;
	testPriceRuleSets: TestPriceRuleSet[];
	type: TestType;
	startDate: string | null;
	endDate: string | null;
	state: TestState;
	createdAt: string;
	deletedAt: string | null;
	testEvent: TestEvent[];
	testWidgetConfiguration: TestWidgetConfiguration[];
}

export interface TestEvent {
	id: string;
	testId: string;
	test: Test;
	type: string;
	metadata: object;
	sessionId: string;
	orderId: string | null;
	testPriceRuleSetId: string | null;
	testPriceRuleSet: TestPriceRuleSet | null;
	createdAt: string;
}

export interface GeneralSetting {
	id: string;
	storeId: string;
	store: Store;
	enableCancelAfterPurchase: boolean;
	cancelAfterPurchaseDurationSeconds: number | null;
	sendConfirmationEmail: boolean;
	sendSmsUpdates: boolean;
	sendStoreCreditEmail: boolean;
	whenToFulfill: FulfillmentTime | null;
	enableOneTimeAppeasements: boolean;
	maximumRefundAmount: number | null;
	otaLimit: OtaLimit | null;
	refundToOriginalPaymentMethod: boolean;
	reshipToCustomer: boolean;
	otaHeader: string;
	otaBodyText: string;
	replacementOrderCost: ReplacementCost;
	refundBasis: ResolutionValueBasis;
	storeCreditBasis: ResolutionValueBasis;
	storeCreditType: StoreCreditType | null;
	storeCreditBonus: number | null;
	storeCreditBonusType: CalcMethod | null;
	offerStoreCreditOnOpPurchase: boolean;
	storeCreditMaxPercentage: number | null;
	waitingPeriodDelivered: number | null;
	waitingPeriodInTransitUS: number | null;
	waitingPeriodInTransitIntl: number | null;
	maxClaimFilingWindow: number;
	trustedCustomerBonus: number;
	trustedMinimumPriorOrders: number;
	highRiskWindow: number;
	daysInPendingNoResponse: number | null;
	daysInOnHold: number | null;
	inventoryManagement: InventoryManagement;
	allowBackorderReship: boolean;
	customerDisclaimer: string;
	claimReimbursementAmount: boolean;
	widgetErrorReportingEnabled: boolean;
	excludeUkIp: boolean;
	excludeIntlOrders: boolean;
	countryRuleAffected: string[];
	allowedIntlCountries: string[];
	countryRule: CountryRule;
	showBrandFundedWidget: boolean;
	coverageMode: CoverageMode;
	updatedByApplicationId: string | null;
	createdAt: string;
	updatedAt: string | null;
	deletedAt: string | null;
}

export interface PartnerSettingsContext {
	id: string;
	storeId: string;
	applicationId: string;
	name: string;
	enableCancelAfterPurchase: boolean | null;
	cancelAfterPurchaseDurationSeconds: number | null;
	sendConfirmationEmail: boolean | null;
	sendSmsUpdates: boolean | null;
	whenToFulfill: FulfillmentTime | null;
	enableOneTimeAppeasements: boolean | null;
	maximumRefundAmount: number | null;
	otaLimit: OtaLimit | null;
	refundToOriginalPaymentMethod: boolean | null;
	reshipToCustomer: boolean | null;
	otaHeader: string | null;
	otaBodyText: string | null;
	replacementOrderCost: ReplacementCost | null;
	storeCreditType: StoreCreditType | null;
	storeCreditBonus: number | null;
	storeCreditBonusType: CalcMethod | null;
	offerStoreCreditOnOpPurchase: boolean | null;
	storeCreditMaxPercentage: number | null;
	waitingPeriodDelivered: number | null;
	waitingPeriodInTransitUS: number | null;
	waitingPeriodInTransitIntl: number | null;
	maxClaimFilingWindow: number | null;
	daysInPendingNoResponse: number | null;
	daysInOnHold: number | null;
	inventoryManagement: InventoryManagement | null;
	allowBackorderReship: boolean | null;
	customerDisclaimer: string | null;
	claimReimbursementAmount: boolean | null;
	widgetErrorReportingEnabled: boolean | null;
	excludeUkIp: boolean | null;
	excludeIntlOrders: boolean | null;
	showBrandFundedWidget: boolean | null;
	store: Store;
	pricingRules: PartnerPriceRuleSet[];
	widgetConfigurations: PartnerWidgetConfiguration[];
	createdAt: string;
	updatedAt: string | null;
	deletedAt: string | null;
}

export interface PartnerPriceRuleSet {
	id: string;
	contextId: string;
	variantKey: string;
	type: PriceRuleSetType;
	automaticallyAddToCart: boolean;
	noOp: boolean;
	autoAddStateBlockList: string[];
	autoAddCountryBlockList: string[];
	context: PartnerSettingsContext;
	rules: PartnerPriceRule[];
	createdAt: string;
	updatedAt: string | null;
}

export interface PartnerPriceRule {
	id: string;
	minValue: number | null;
	maxValue: number;
	brandCalcMethod: CalcMethod | null;
	brandPrice: number | null;
	customerCalcMethod: CalcMethod | null;
	customerPrice: number | null;
	hybridOperator: PricingOperator | null;
	ruleSet: PartnerPriceRuleSet;
	partnerRuleSetId: string;
	pricingModel: PricingModel | null;
	warrantyDuration: string | null;
	createdAt: string;
	updatedAt: string | null;
	deletedAt: string | null;
}

export interface PartnerWidgetConfiguration {
	id: string;
	contextId: string;
	variantKey: string;
	brandId: string | null;
	status: WidgetStatus;
	identifier: string;
	type: WidgetType;
	variant: string | null;
	name: string | null;
	config: object | null;
	customizationValues: object | null;
	context: PartnerSettingsContext;
	createdAt: string;
	updatedAt: string | null;
}

export interface Sop {
	id: string;
	title: string;
	storeId: string;
	store: Store;
	state: SopState;
	source: SopSource;
	sourceKey: string | null;
	lastRefreshedAt: string | null;
	createdAt: string;
	updatedAt: string | null;
	deletedAt: string | null;
	sopHistories: SopHistory[];
}

export interface SopHistory {
	id: string;
	content: string;
	sopId: string;
	sop: Sop;
	metadata: object | null;
	createdAt: string;
	updatedAt: string | null;
	deletedAt: string | null;
}

export interface HelpDeskSopSettings {
	id: string;
	storeId: string;
	store: Store;
	channels: string[];
	refreshCadence: SopRefreshCadence;
	slackChannelIds: string[];
	slackRefreshCadence: SopRefreshCadence;
	createdAt: string;
	updatedAt: string | null;
}

export interface WidgetConfiguration {
	id: string;
	brandId: string | null;
	status: WidgetStatus;
	identifier: string;
	type: WidgetType;
	variant: string | null;
	storeId: string | null;
	store: Store | null;
	name: string | null;
	config: object | null;
	customizationValues: object | null;
	updatedByApplicationId: string | null;
	createdAt: string;
	updatedAt: string | null;
	deletedAt: string | null;
	testWidgetConfiguration: TestWidgetConfiguration[];
}

export interface TestWidgetConfiguration {
	id: string;
	testId: string;
	test: Test;
	title: string;
	isOriginal: boolean;
	widgetConfigurationId: string;
	widgetConfiguration: WidgetConfiguration;
	createdAt: string;
	updatedAt: string | null;
	deletedAt: string | null;
}

export interface StoreReinstallRequest {
	id: string;
	token: string;
	email: string;
	storeId: string;
	validUntil: string;
	createdAt: string;
}

export interface CustomDomain {
	id: string;
	storeId: string;
	store: Store;
	domain: string;
	status: CustomDomainStatus;
	authorizationMode: CustomDomainAuthMode;
	gcpCertificateName: string | null;
	gcpDnsAuthName: string | null;
	gcpMapEntryName: string | null;
	dnsRecords: object | null;
	contactEmail: string | null;
	lastError: string | null;
	attempts: number;
	notificationsSuppressed: boolean;
	provisioningStartedAt: string;
	aRecordOk: boolean;
	certActiveAt: string | null;
	availableNotifiedAt: string | null;
	createdAt: string;
	updatedAt: string | null;
}

